<template>
    <div>
        <multiselect
            :max-height="max_height ? max_height : 300"
            :id="id"
            :loading="isLoading"
            v-model="user_group"
            tag-placeholder=""
            placeholder=""
            :options="user_groups_select"
            :close-on-select="true"
            :clear-on-select="false"
            label="title" track-by="id"
            :taggable="true"
            :selectedLabel="''"
            :placeholder="''"
            :selectLabel="''"
            :deselectLabel="''"
            :tagPlaceholder="''"
            :showNoOptions="false"
            :searchable="true"
            :disabled="disabled"
            group-values="items"
            group-label="group_name"
        >
            <template slot="option" slot-scope="props">
                <span v-if="props.option.label" class="option__title">{{props.option.label}}</span>
                <span v-if="props.option.$groupLabel" class="option__title">{{props.option.$groupLabel}}</span>
                <span v-if="props.option.title" class="option__title">{{ props.option.title }}</span>

                <a v-if="props.option.id && $hasPermission('user_groups.update')" @click="showEdit(props.option.id)" class="small text-muted">{{props.option.$groupLabel}} редактировать</a>
            </template>
            <template slot="beforeList" v-if="$hasPermission('user_groups.create')">
                <li class="multiselect__element"><span class="multiselect__option"><a @click="showCreate()" class="option__title">Добавить</a></span></li>
            </template>
        </multiselect>
        <el-dialog :title="form_mode === 'create' ? 'Создание группы юзеров' : 'Редактирование группы юзеров'" :visible.sync="form_state" width="450px" :append-to-body="true">
            <UserGroupForm v-if="form_state" :mode="form_mode" :obj="form_owner" @created="onCreated" @updated="onUpdated"/>
        </el-dialog>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
import UserGroupForm from "./UserGroupForm.vue";
export default {
    name: "UserGroupSelect",
    components: {UserGroupForm, Multiselect},
    props: ['value', 'id', 'init_value', 'filter_platforms', 'max_height', 'disabled'],
    data: () => ({
        user_group: null,
        user_groups: [],

        form_state: false,
        form_mode: null,
        form_owner: null,
        isLoading: false,
        options_ajax_find: [],
    }),
    mounted() {
        let self = this;

        this.isLoading = true;
        axios.get('/api/user_groups')
            .then(response => {
                self.user_groups = response.data;
                self.isLoading = false;

                self.user_groups_select.forEach(group => {
                    group.items.forEach(item => {
                        if (+item.id === +self.value) self.user_group = item;
                    })
                })
            });
    },
    watch: {
        user_group(val) {
            this.$emit('input', val ? val.id : null);
        },
        value(val) {
            if (this.init_value && this.init_value.id === this.value) this.user_group = this.init_value;
            let self = this;
            let i = setInterval(() => {
                if (self.isLoading === false) {
                    clearInterval(i);
                    self.user_groups_select.forEach(group => {
                        group.items.forEach(item => {
                            if (+item.id === +val) self.user_group = item;
                        })
                    })
                }
            }, 1000)
        }
    },
    computed: {
        user_groups_select() {
            let data = {};
            let self = this;
            let options = _.clone(this.user_groups);
            let only_platforms_ids = this.filter_platforms ? this.filter_platforms : null;
            options.forEach(function (item) {
                if (only_platforms_ids && !only_platforms_ids.includes(item.platform_id)) return;
                if (!data[item.platform_id]) data[item.platform_id] = {group_name: PlatformHelper.get(item.platform_id).name, items: []}

                data[item.platform_id].items.push({
                    id: item.id,
                    platform_id: item.platform_id,
                    title: item.name,
                });
            });
            data = _.mapValues(data, function (item) {
                item.items = _.sortBy(item.items, ['title'])
                return item;
            });
            return _.values(data);
        }
    },
    methods: {
        showEdit(id) {
            this.form_mode = 'edit';
            this.form_owner = _.find(this.user_groups, {id: id});
            this.form_state = true;
        },
        showCreate() {
            this.form_mode = 'create';
            this.form_state = true;
        },
        onCreated(owner) {
            let self = this;
            this.user_groups.push(owner);
            this.form_state = false;
            this.user_groups_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === owner.id) self.user_group = item;
                })
            })
        },
        onUpdated(owner) {
            let self = this;
            this.form_state = false;
            this.user_groups = this.user_groups.map(item => {
                if(item.id === owner.id) item = owner;
                return item;
            })
            this.user_groups_select.forEach(group => {
                group.items.forEach(item => {
                    if (item.id === owner.id) self.user_group = item;
                })
            })
        }
    }
}
</script>

<style scoped>

</style>
